import actionTypes from './actionTypes'
import confirmTypes from 'helpers/enums/confirmTypes'

const myAccountActions = {
	initializeMyAccountBase() {
		return {
			type: actionTypes.MY_ACCOUNT_INITIALIZE_BASE,
		}
	},

	menuUpgrade() {
		return {
			type: actionTypes.MY_ACCOUNT_MENU_UPGRADE,
		}
	},

	menuFreeUpgrade() {
		return {
			type: actionTypes.MY_ACCOUNT_MENU_FREE_UPGRADE,
		}
	},

	getMyAccountData() {
		return {
			type: actionTypes.MY_ACCOUNT_GET_DATA,
		}
	},

	savePersonalInfo(values, resolve, reject) {
		return {
			type: actionTypes.MY_ACCOUNT_SAVE_PERSONAL_INFO,
			...values,
			resolve,
			reject,
		}
	},

	saveSchoolInfo(values, resolve, reject) {
		return {
			...values,
			resolve,
			reject,
			type: actionTypes.MY_ACCOUNT_SAVE_SCHOOL_INFO,
		}
	},

	saveSchoolInfoSuccess(countryId, stateId, city, institutionId, institutionName) {
		return {
			type: actionTypes.MY_ACCOUNT_SAVE_SCHOOL_INFO_SUCCESS,
			countryId,
			stateId,
			institutionId,
			institutionName,
			city,
		}
	},

	saveSchoolInfoFailed(message) {
		return {
			type: actionTypes.MY_ACCOUNT_SAVE_SCHOOL_INFO_FAILED,
			message,
		}
	},

	saveTeacherInfo(values) {
		return {
			...values,
			type: actionTypes.MY_ACCOUNT_SAVE_TEACHER_INFO,
		}
	},

	searchSchools(search, countryId, stateId, checkRolePermission) {
		return {
			search,
			countryId,
			stateId,
			checkRolePermission,
			type: actionTypes.MY_ACCOUNT_SEARCH_SCHOOLS,
		}
	},

	changeCountry() {
		return {
			type: actionTypes.MY_ACCOUNT_CHANGE_COUNTRY,
		}
	},

	changeState() {
		return {
			type: actionTypes.MY_ACCOUNT_CHANGE_STATE,
		}
	},

	showSchoolButtons(value) {
		return {
			show: value,
			type: actionTypes.MY_ACCOUNT_SHOW_SCHOOL_BUTTONS,
		}
	},

	showTeacherButtons(value) {
		return {
			show: value,
			type: actionTypes.MY_ACCOUNT_SHOW_TEACHER_BUTTONS,
		}
	},

	saveAdvancedSettings(index) {
		return {
			index,
			type: actionTypes.MY_ACCOUNT_SAVE_ADVANCED_SETTINGS,
		}
	},

	initializeMyAccountAdvanced() {
		return {
			type: actionTypes.MY_ACCOUNT_INITIALIZE_ADVANCED_SETTINGS,
		}
	},

	initializeMyAccountNotifications() {
		return {
			type: actionTypes.MY_ACCOUNT_INITIALIZE_NOTIFICATIONS,
		}
	},

	showAdvancedSettingsConfirmMessage(index) {
		return {
			type: actionTypes.OPEN_CONFIRM,
			confirmType: confirmTypes.MY_ACCOUNT_ADVANCED_ENABLE_SETTING,
			confirmProps: {
				index,
			},
		}
	},

	avatarClick() {
		return {
			type: actionTypes.MY_ACCOUNT_AVATAR_CLICK,
		}
	},

	closeNearpodPicker() {
		return {
			type: actionTypes.MY_ACCOUNT_NEARPOD_PICKER_CANCEL,
		}
	},

	uploadProfileImage(allowedTypes, files, featureType, featureId) {
		return {
			type: actionTypes.MY_ACCOUNT_UPLOAD_PROFILE_IMAGE,
			allowedTypes,
			files,
			featureType,
			featureId,
		}
	},

	uploadProfileImageError(message) {
		return {
			type: actionTypes.MY_ACCOUNT_UPLOAD_PROFILE_IMAGE_ERROR,
			message,
		}
	},

	changePassword(values, resolve, reject) {
		return {
			type: actionTypes.MY_ACCOUNT_CHANGE_PASSWORD,
			...values,
			resolve,
			reject,
		}
	},

	changePasswordSuccess(message) {
		return {
			type: actionTypes.MY_ACCOUNT_CHANGE_PASSWORD_SUCCESS,
			message,
		}
	},

	changePasswordFailed(errors) {
		return {
			type: actionTypes.MY_ACCOUNT_CHANGE_PASSWORD_FAILED,
			errors,
		}
	},

	showPasswordForm() {
		return {
			type: actionTypes.MY_ACCOUNT_SHOW_PASSWORD_FORM,
		}
	},

	closePasswordForm() {
		return {
			type: actionTypes.MY_ACCOUNT_CLOSE_PASSWORD_FORM,
		}
	},

	finalizeMyAccountBase() {
		return {
			type: actionTypes.MY_ACCOUNT_FINALIZE_BASE,
		}
	},

	handlePaymentDetails() {
		return {
			type: actionTypes.MY_ACCOUNT_PAYMENT_DETAILS_SELECTED,
		}
	},

	saveIconSuccess(icon, userId) {
		return {
			type: actionTypes.MY_ACCOUNT_SAVE_ICON_SUCCESS,
			icon,
			userId,
		}
	},
}

export default myAccountActions
